(()=>{
 const dialog=document.getElementById('TTAvailabilityRequest');
 if(!dialog)return;
 let returnFocus;
 const contextKey='tt-availability-request-context';
 const apply=context=>{
  dialog.querySelectorAll('[data-availability-field]').forEach(input=>{input.value=context[input.dataset.availabilityField]||'';});
  const quantity=dialog.querySelector('[data-availability-field="quantity"]');
  quantity?.dispatchEvent(new Event('change',{bubbles:true}));
  dialog.querySelector('[data-availability-summary]').textContent=[context.product,context.variant,context.sku,context.search].filter(Boolean).join(' · ');
 };
 const open=context=>{
  returnFocus=document.activeElement;
  apply(context);
  try{sessionStorage.setItem(contextKey,JSON.stringify(context));}catch{}
  if(!dialog.open)dialog.showModal();
 };
 const rememberQuantity=()=>{
  try{
   const context=JSON.parse(sessionStorage.getItem(contextKey)||'null');
   const quantity=dialog.querySelector('[data-availability-field="quantity"]');
   if(context&&quantity){context.quantity=quantity.value;sessionStorage.setItem(contextKey,JSON.stringify(context));}
  }catch{}
 };
 dialog.addEventListener('input',event=>{if(event.target.matches('[data-availability-field="quantity"]'))rememberQuantity();});
 dialog.querySelector('form')?.addEventListener('submit',rememberQuantity);
 const close=()=>{dialog.close();try{sessionStorage.removeItem(contextKey);}catch{}returnFocus?.focus();};
 dialog.querySelector('[data-availability-close]').addEventListener('click',close);
 dialog.addEventListener('cancel',()=>{try{sessionStorage.removeItem(contextKey);}catch{}queueMicrotask(()=>returnFocus?.focus());});
 dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close();}});
 window.TechToolAvailability={open};
 document.addEventListener('click',event=>{
  const link=event.target.closest('a[data-product-quote-link],a[data-schunk-quote],a[data-availability-link]');
  if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const url=new URL(link.href,location.origin);
  if(url.origin!==location.origin||url.searchParams.get('type')!=='quote')return;
  event.preventDefault();
  open({search:url.searchParams.get('search')||'',product:url.searchParams.get('product')||'',manufacturer:url.searchParams.get('manufacturer')||'',sku:url.searchParams.get('sku')||'',variant:url.searchParams.get('variant')||'',quantity:url.searchParams.get('quantity')||'1',url:location.href});
 });
 if(dialog.querySelector('[data-availability-success],[data-availability-errors]')){
  let context;try{context=JSON.parse(sessionStorage.getItem(contextKey)||'null');}catch{}
  if(context){apply(context);dialog.showModal();}
  if(dialog.querySelector('[data-availability-success]')){try{sessionStorage.removeItem(contextKey);}catch{}}
 }
})();
